import * as Primitives from "@radix-ui/react-radio-group"
import { clx } from "../utils/clx"

type RadioGroupCardItemProps = {
  label: string
} & Primitives.RadioGroupItemProps &
  React.RefAttributes<HTMLButtonElement>

const RadioGroupCardRoot = Primitives.Root

const RadioGroupCardItem = ({
  label,
  className,
  disabled,
  children,
  ...rest
}: RadioGroupCardItemProps) => {
  return (
    <Primitives.Item
        {...rest}
        id={rest.value}
        disabled={disabled}
        className={clx(
          "shadow-borders-with-shadow border border-ui-border-strong bg-grey-0 hover:bg-ui-bg-base-hover px-3.5 py-1 gap-base txt-base-regular-plus text-ui-fg-base rounded-md",
          "data-[state=checked]:bg-blue-lighter data-[state=checked]:text-blue-base data-[state=checked]:border-blue-base focus-visible:border-none focus-visible:outline-none focus-visible:shadow-buttons-focus",
          { "disabled:bg-ui-bg-disabled disabled:text-ui-fg-muted": disabled },
          className
        )}
      >
        <label
          htmlFor={rest.value}
          className={clx(
          "relative flex items-center justify-center cursor-pointer",
          className
        )}
        >
          {label}
        </label>
      </Primitives.Item>
  )
}

const RadioGroupCard = Object.assign(RadioGroupCardRoot, {
  Item: RadioGroupCardItem,
})

export { RadioGroupCard }
